import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/BoardOfDirectorsPage.css";

const directors = [
  {
    id: "capt-jagmohan",
    name: "CAPT. JAGMOHAN (RETD.)",
    title: "Non Executive Chairman",
    image: "/wp-content/uploads/2026/Capt Jagmohan.jpg",
    description:
      "Appointed as a Non-executive/Non-independent director nominated by Mazagon Dock Shipbuilders Ltd. to the Colombo Dockyard PLC board on the 24th of February 2026. Capt. Jagmohan (Retd.) serves as Chairman & Managing Director of the Mazagon Dock Shipbuilders Limited w.e.f. 21 April 2025. He is a Naval Architect from Cochin University of Science & Technology...",
  },
  {
    id: "thimira-s-godakumbura",
    name: "Thimira S. Godakumbura",
    title: "Managing Director/CEO",
    image: "/wp-content/uploads/2024/03/Photo-03-163x222.jpg",
    description:
      "Appointed to the Colombo Dockyard PLC (CDPLC) board on the 19th of April 2023 as the Managing Director / Chief Executive Officer. Before being appointed as the MD/CEO Mr. Godakumbura was the Chief Operating Officer (COO) for one and a half years. He brings more than 22 years of experience...",
  },
  {
    id: "biju-george",
    name: "BIJU GEORGE",
    title: "Director (Non-executive / Non-independent)",
    image: "/wp-content/uploads/2026/Mr. Biju R1.jpg",
    description:
      "Appointed as a Non-executive/Non-independent director nominated by Mazagon Dock Shipbuilders Ltd. to the Colombo Dockyard PLC board on the 24th of February 2026. Mr. Biju George serves as the Director (Shipbuilding) of Mazagon Dock Shipbuilders Limited (MDL) w.e.f. 27.10.2021...",
  },
  {
    id: "ruchir-agrawal",
    name: "RUCHIR AGRAWAL",
    title: "Director (Non-executive / Non-independent)",
    image: "/wp-content/uploads/2026/Mr. Ruchir.jpg",
    description:
      "Qualifications: B com, AICWA. Appointed as a Non-executive/Non-independent director nominated by Mazagon Dock Shipbuilders Ltd. to the Colombo Dockyard PLC board on the 24th of February 2026. Mr. Ruchir Agrawal serves as the Director (Finance) of Mazagon Dock Shipbuilders Limited (MDL)...",
  },
  {
    id: "vish-govindasamy",
    name: "VISH GOVINDASAMY",
    title: "Director (Non-executive / Non-independent)",
    image: "/wp-content/uploads/2026/Mr. Govindasami.jpg",
    description:
      "Mr. Govindasamy serves as the Deputy Chairman of Sunshine Holdings PLC. He is a Non Executive Director of Sunshine Holdings PLC and Watawala Plantations PLC, and also holds Independent Non-Executive board positions at Softlogic Life Insurance PLC, Dialog Axiata PLC, United Motors Lanka PLC and Lanka Island Resort Ltd.",
  },
  {
    id: "senthilverl-senthi-nandhanan",
    name: "SENTHILVERL SENTHI NANDHANAN",
    title: "Director (Non-executive / Non-independent)",
    image: "/wp-content/uploads/2026/Mr. Nandhanan.jpg",
    description:
      "Mr. S. Senthi Nandhanan is a distinguished corporate leader with over two decades of experience across the financial services, energy, FMCG, and investment sectors. Known for driving sustainable growth and optimizing supply chains, he specializes in strategic decision-making and corporate governance.",
  },
  {
    id: "dilrukshi-kurukulasuria",
    name: "DILRUKSHI KURUKULASURIA",
    title: "Director (Non-executive / Independent)",
    image: "/wp-content/uploads/2026/dilrukshi.png",
    description:
    "Appointed as a non-executive/independent director with effect from 19th of May 2026, Ms. Dilrukshi Kurukulasuriya is the Executive Director and Chief Human Resources Officer of DIMO PLC. A qualified Attorney-at-Law, she also holds an Executive MBA from the University of West London and has completed specialized training in gender studies through the ILO’s International Training Centre in Turin."
  },
  {
    id: "chaminda-gunasinghe",
    name: "Chaminda Gunasinghe",
    title: "Director",
    image: "/wp-content/uploads/Chaminda Gunasinghe 1.png",
    description:
      "Mr. Chaminda Gunasinghe is a distinguished Finance, taxation, audit, Administration, Human Resources professional with over 26 years of experience in Banking, Finance and Insurance sectors. He joined SLIC in 2007 as an Accountant and served in many positions...",
  },
  {
    id: "chanaka-jayamaha",
    name: "Chanaka A. M. Jayamaha",
    title: "Director",
    image: "/wp-content/uploads/2024/03/Photo-02-153x220.jpg",
    description:
      "Chanaka Jayamaha counts 20 years of practice as an Attorney-at-Law. He is a Civil/Commercial Lawyer specializing in litigation and Arbitrations. His vast areas of expertise include Banking and Finance, Insurance, Intellectual Property, Shipping Law, Construction Law, Sports Law and Labour disputes.",
  },
  {
    id: "chathura-wickramatilleka",
    name: "CHATHURA CHANAKA WICKRAMATILEKA",
    title: "Director",
    image: "/wp-content/uploads/2023/06/chathura-chanaka.jpg",
    description:
      "Chathura is a CFA Charter holder, an Associate Member of the Institute of Chartered Accountants of Sri Lanka, an Associate Member of the Chartered Institute of Management Accountants and holds a bachelor's degree in management from the University of London.",
  },
];

const BoardOfDirectorsPage = () => {
  return (
    <>
      <Header />

      {/* Hero Banner */}
      <section
        className="board-banner"
        style={{
          backgroundImage: "url('/wp-content/uploads/2016/02/new ship 1.jpg')",
        }}
      ></section>

      <div className="board-directors-wrapper">
        <div className="center-container">
          {/* Breadcrumb */}
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Board of Directors</span>
          </div>

          <h1 className="page-title" data-aos="fade-right">
            Board of Directors
          </h1>

          {/* Directors Grid */}
          <div className="directors-grid">
            {directors.map((director, index) => (
              <div
                key={director.id}
                className="director-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="director-image">
                  <img src={director.image} alt={director.name} data-aos="fade-down" />
                </div>
                <div className="director-info" data-aos="fade-up">
                  <h2>{director.name}</h2>
                  <p className="director-title">{director.title}</p>
                  <hr className="director-hr" />
                  <p className="director-description">{director.description}</p>
                  <Link
                    to={`/board-of-directors/${director.id}`}
                    className="view-more"
                  >
                    View more
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default BoardOfDirectorsPage;
